import { environment } from '../../environments/environment';
import { normalizeEmail, resolveUserEmail } from '../item-details/item-utils';

/**
 * Recommendations audit dashboard: env-gated by predictions flag + email allowlist.
 * Empty allowlist = nobody (secure default).
 */
export function canAccessRecommendationsAudit(email?: string | null): boolean {
    if (!environment.predictionsRecommendationsEnabled) {
        return false;
    }
    const allowed = String((environment as { recommendationsAuditAllowedEmails?: string }).recommendationsAuditAllowedEmails || '')
        .split(',')
        .map((e) => normalizeEmail(e))
        .filter(Boolean);
    if (!allowed.length) {
        return false;
    }
    const user = normalizeEmail(email ?? resolveUserEmail(null));
    return !!user && allowed.includes(user);
}
